import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from '../FieldGroup';

export default class RegistrationFormField extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    available: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    errorMessage: PropTypes.object,
    fieldName: PropTypes.string,
    editable: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.renderChildren = this.renderChildren.bind(this);
  }

  renderChildren() {
    if (this.props.children) {
      let child = React.Children.only(this.props.children);
      return React.cloneElement(child, {
        name: this.props.name,
        fieldName: this.props.fieldName,
        disabled: !this.props.editable,
        errorMessage: this.props.errorMessage ? this.props.errorMessage.message : null
      });
    }
  }

  render() {
    //don't want to pass name through, FieldGroup thinks that's to be pre-pended on all nested controls
    const { name, ...newProps } = this.props; //eslint-disable-line no-unused-vars
    if (this.props.available) {
      return (<FieldGroup {...newProps}>
        {this.renderChildren()}
      </FieldGroup>)
    } else {
      return null;
    }
  }
}
